import React from "react";
import { CheckCircle2, HelpCircle } from "lucide-react";

const KIND = { base: "Base suite", suite: "Suite add-on", addon: "Add-on", free: "Free / trial", unknown: "Unknown" };

/** Product names found in the export -> the SKU they were matched to. */
export default function CsvProductTable({ products, counts }) {
  if (!products) return <p className="muted small">Matching product names…</p>;
  const unknown = products.filter((p) => !p.known).length;
  return (
    <div className="ws-stack" data-testid="csv-products">
      <p className="muted small" data-testid="csv-products-summary">
        {products.length} product name{products.length === 1 ? "" : "s"} found · {products.length - unknown} matched to the license matrix{unknown ? ` · ${unknown} unknown (kept as-is, excluded from pricing)` : ""}.
      </p>
      <div className="ws-table-wrap tall">
        <table className="perm-table">
          <thead>
            <tr>
              <th>In your export</th>
              <th>Matched SKU</th>
              <th>Kind</th>
              <th className="num">Users</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p.input} data-testid={`csv-product-${p.part_number}`}>
                <td>{p.input}</td>
                <td className="mono small">{p.known ? p.part_number : "—"}</td>
                <td>
                  <span className={`mini-chip ${p.known ? (p.kind === "base" ? "ok" : "") : "warn"}`}>
                    {p.known ? <CheckCircle2 size={10} /> : <HelpCircle size={10} />} {KIND[p.kind] || p.kind}
                  </span>
                </td>
                <td className="num mono">{(counts[p.input] || 0).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
